/**
 * LoggedIn form component.
 *
 * @returns {JSX.Element}
 */
// State action for update/set rule config.
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {__} from "@wordpress/i18n";

// State action for update/set rule config.
import {setRuleConfig} from "@app/modules/PersonaForm/store/PersonaFormStore";

// Components.
import Label from "@app/components/Label";
import Input from "@app/components/Input";

const ruleID = "ReturningCustom";

export default function ReturningCustom({id = ruleID}) {
	const dispatch = useDispatch();
	const rule = useSelector((state) =>
		state.ruleSets.find((rule) => rule.id === id),
	);
	const [returnValue, setReturnValue] = useState(
		rule.config?.args?.visit_count || "",
	);

	useEffect(() => {
		dispatch(
			setRuleConfig({
				id: id,
				config: {
					ruleType: "returning_visitor",
					args: {
						visit_count: returnValue,
						id: ruleID,
					},
				},
			}),
		);
	}, [returnValue]);

	return (
		<div>
			<Label title={__("Custom Return Visit Number", "dxp")} />
			<Input
				type="number"
				variant="small"
				min="1"
				value={returnValue}
				placeholder={__("User is returning for the n-th time", "dxp")}
				onChange={(e) => setReturnValue(e.target.value)}
			/>
		</div>
	);
}
